import { createSlice } from '@reduxjs/toolkit';

import { CalendarViewEnum } from '@shared/enums/calendarView.enum';
import { reformatCalendarItem } from '@shared/functions/reformatCalendarItem';

import type { PayloadAction } from '@reduxjs/toolkit';

export type CalendarFiltersType = {
  entities?: string[] | null;
  event_statuses?: string[] | null;
  task_statuses?: string[] | null;
  payment_statuses?: string[] | null;
  tags?: string[] | null;
  query?: string | null;
};

export interface CalendarState {
  isShowCalendarNavigationPanel: boolean;
  calendarData: any;
  selectedCalendarView: CalendarViewEnum;
  isFetchingWithFilter: boolean;
  isFetchingInitialData: boolean;
  filters: CalendarFiltersType;
  query: string | null;
  initialDate: Date | null;
}

const initialState: CalendarState = {
  isFetchingInitialData: false,
  selectedCalendarView: JSON.parse(localStorage.getItem('selectedCalendarView') as string)
    ? JSON.parse(localStorage.getItem('selectedCalendarView') as string)
    : CalendarViewEnum.month,
  isShowCalendarNavigationPanel:
    typeof JSON.parse(localStorage.getItem('calendarNavigationPanel') as string) === 'boolean'
      ? JSON.parse(localStorage.getItem('calendarNavigationPanel') as string)
      : true,
  calendarData: [],
  query: '',
  isFetchingWithFilter: false,
  initialDate: null,
  filters: {
    entities: null,
    event_statuses: null,
    task_statuses: null,
    payment_statuses: null,
    tags: null,
    query: '',
  },
};

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    toggleShowCalendarNavigationPanel: (state, action: PayloadAction<boolean>) => {
      state.isShowCalendarNavigationPanel = action.payload;
    },
    setCalendarFilters: (state, action: PayloadAction<object>) => {
      state.filters = action.payload;
    },
    setCalendarQuery: (state, action: PayloadAction<string | null>) => {
      state.query = action.payload;
    },
    setSelectedCalendarView: (state, action: PayloadAction<CalendarViewEnum>) => {
      localStorage.setItem('selectedCalendarView', JSON.stringify(action.payload));
      state.selectedCalendarView = action.payload;
    },
    setCalendarDate: (state, action: PayloadAction<any>) => {
      state.calendarData = action.payload;
    },
    addedCalendarItem: (state, action: PayloadAction<{ data: any; isStarterPackage: boolean }>) => {
      state.calendarData.push(reformatCalendarItem(action.payload.data, false, state.selectedCalendarView));
    },
    updateCalendarItem: (state, action: PayloadAction<any>) => {
      state.calendarData = state.calendarData.map((item: any) => {
        if (item.id === action.payload.id) {
          return reformatCalendarItem(action.payload, false, state.selectedCalendarView);
        }
        return item;
      });
    },
    removeCalendarItem: (state, action: PayloadAction<number>) => {
      state.calendarData = state.calendarData.filter((item: any) => item.id !== action.payload);
    },
    setInitialDate: (state, action: PayloadAction<Date | null>) => {
      state.initialDate = action.payload;
    },
    resetCalendarData: (state) => {
      return { ...initialState, filters: state.filters, selectedCalendarView: state.selectedCalendarView };
    },
  },
});

export const {
  toggleShowCalendarNavigationPanel,
  setSelectedCalendarView,
  setCalendarDate,
  addedCalendarItem,
  updateCalendarItem,
  setInitialDate,
  removeCalendarItem,
  setCalendarFilters,
  resetCalendarData,
  setCalendarQuery,
} = calendarSlice.actions;
export default calendarSlice.reducer;
